import api from '../../fetch/api'
export default {
  data () {
    return {
      params:{
        platform:'browser',
        keycode:''

      }
    }
  },
  mounted () {
    this.init()
  },

  methods: {
    init () {
      let domT = document.querySelector('#txt');
      if (/MicroMessenger/.test(window.navigator.userAgent)) {
        //微信暂时引导用户去支付宝
        this.params.platform = "WeChat";
        this.saveVistRecord();
        window.location.href = '/#/wechat';
      } else if (/AlipayClient/.test(window.navigator.userAgent)) {
        this.params.platform = "Alipay";
        this.saveVistRecord();
        window.location.href = '/#/alipay';
        // window.location.href='https://qr.alipay.com/s6x04348cttjw1kxw5nkf09';
      } else {
        this.params.platform = "Browser";
        this.saveVistRecord();
        window.location.href = '/#/browser';
        //window.location.href="alipays://platformapi/startapp?appId=2019091867517963";
      }

    },
    saveVistRecord(){
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      let keycode = "[QRCODE]["+currentdate+"]";
      this.params.keycode = keycode;
      api.saveVistRecord(this.params).then(res => {
      })
    }


  }
}



// WEBPACK FOOTER //
// ./src/page/miniUrl/miniQrcode.js